/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Email_InvalidInputs */

const nl_validation_email_invalid = /** @type {(inputs: Validation_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer een geldig e-mailadres in`)
};

/**

* @param {Validation_Email_InvalidInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const validation_email_invalid = /** @type {((inputs?: Validation_Email_InvalidInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Email_InvalidInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_validation_email_invalid(inputs)
});
export { validation_email_invalid as "validation.email_invalid" }